import { Box, Divider, Typography } from '@mui/material'
import { StarRateRounded } from '@mui/icons-material'

const JobFitEmptyCard = () => {

  return (
    <>
      <Box
        sx={{
          position: 'relative',
          padding: '40px 30px 30px 30px',
          display: 'flex',
          flexDirection: 'column',
          gap: '42px',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '283px',
            opacity: 0.95,
            backgroundImage: 'linear-gradient(to bottom, #09666A, #30EEE2)',
            borderRadius: '0 0 5% 5%',
          }}
        />
        <Box
          sx={{
            position: 'relative',
            zIndex: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
            <Box display="flex" flexDirection="column" alignItems="center">
              <Box display="flex" flexDirection="row" marginBottom={0.5}>
                <StarRateRounded color="yellow-01" />
                <StarRateRounded color="gray-line" />
                <StarRateRounded color="gray-line" />
                <StarRateRounded color="gray-line" />
                <StarRateRounded color="gray-line" />
              </Box>
              <Typography variant="h3" sx={{ fontWeight: 'medium', color: 'white.main' }}>
                Minimum fit for this job
              </Typography>
            </Box>
          </Typography>
          <Typography
            variant="body1"
            textAlign="center"
            sx={{ color: 'white.main', marginTop: '16px' }}
          >
            The candidate’s skills, experience, and educational background do not align with the
            requirements for the Senior Full-Stack Developer role.
          </Typography>
        </Box>
        <Box
          sx={{
            position: 'relative',
            zIndex: 2,
            borderRadius: '4.5px',
            border: '1px solid #E5E5E5',
            backgroundColor: 'white.main',
          }}
        >
          <Box style={{ width: '100%' }} sx={{ width: 'full' }}>
            <Box
              sx={{
                paddingTop: '20px',
                paddingBottom: '20px',
                display: 'flex',
                flexDirection: 'column',
                gap: '2px',
              }}
            >
              {/* -------------------------- Jobs requirement -------------------------- */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '15px',
                  marginLeft: 6.5,
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  Jobs requirement match
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '15px',
                  marginLeft: 6.5,
                  marginRight: 6.5,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ color: 'light-gray-text.main', fontWeight: 'regular' }}
                >
                  The candidate does not meet any specific technical requirements mentioned such as
                  expertise in JavaScript, Node.js, Angular, etc.
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '15px',
                  marginLeft: 6.5,
                  marginRight: 6.5,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ color: 'light-gray-text.main', fontWeight: 'regular', width: '100%' }}
                >
                  <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    justifyContent="space-between"
                    width="100%"
                  >
                    <Box>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 'medium',
                          color: 'light-gray-text.main',
                          backgroundColor: 'gray-background.main',
                          paddingTop: 1,
                          paddingBottom: 1,
                          paddingRight: 1,
                          paddingLeft: 1,
                        }}
                      >
                        Minimum fit
                      </Typography>
                    </Box>
                    <Box display="flex" flexDirection="row" marginBottom={0.5}>
                      <StarRateRounded color="yellow-01" fontSize="small" />
                      <StarRateRounded color="gray-line" fontSize="small" />
                      <StarRateRounded color="gray-line" fontSize="small" />
                      <StarRateRounded color="gray-line" fontSize="small" />
                      <StarRateRounded color="gray-line" fontSize="small" />
                    </Box>
                  </Box>
                </Typography>
              </Box>
              <Divider
                color="light-gray-text.main"
                sx={{ marginLeft: '40px', marginRight: '40px', opacity: 0.2, marginTop: 1.5 }}
              />
              {/* --------------------------------------------------------------------- */}

              {/* --------------------------- Skills match ---------------------------- */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '15px',
                  marginLeft: 6.5,
                  marginTop: 2.5,
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  Skills match
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '15px',
                  marginLeft: 6.5,
                  marginRight: 6.5,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ color: 'light-gray-text.main', fontWeight: 'regular' }}
                >
                  The candidate does not have any of the programming, database, or full-stack
                  development skills required for the job.
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '15px',
                  marginLeft: 6.5,
                  marginRight: 6.5,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ color: 'light-gray-text.main', fontWeight: 'regular', width: '100%' }}
                >
                  <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    justifyContent="space-between"
                    width="100%"
                  >
                    <Box>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 'medium',
                          color: 'light-gray-text.main',
                          backgroundColor: 'gray-background.main',
                          paddingTop: 1,
                          paddingBottom: 1,
                          paddingRight: 1,
                          paddingLeft: 1,
                        }}
                      >
                        Minimum fit
                      </Typography>
                    </Box>
                    <Box display="flex" flexDirection="row" marginBottom={0.5}>
                      <StarRateRounded color="yellow-01" fontSize="small" />
                      <StarRateRounded color="gray-line" fontSize="small" />
                      <StarRateRounded color="gray-line" fontSize="small" />
                      <StarRateRounded color="gray-line" fontSize="small" />
                      <StarRateRounded color="gray-line" fontSize="small" />
                    </Box>
                  </Box>
                </Typography>
              </Box>
              <Divider
                color="light-gray-text.main"
                sx={{ marginLeft: '40px', marginRight: '40px', opacity: 0.2, marginTop: 1.5 }}
              />
              {/* --------------------------------------------------------------------- */}

              {/* ----------------------- Experience relevance ------------------------ */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '15px',
                  marginLeft: 6.5,
                  marginTop: 2.5,
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  Experience relevance
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '15px',
                  marginLeft: 6.5,
                  marginRight: 6.5,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ color: 'light-gray-text.main', fontWeight: 'regular' }}
                >
                  The candidate's experience is primarily in customer service, marketing, and
                  communications, with no relevant experience in software development.
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '15px',
                  marginLeft: 6.5,
                  marginRight: 6.5,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ color: 'light-gray-text.main', fontWeight: 'regular', width: '100%' }}
                >
                  <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    justifyContent="space-between"
                    width="100%"
                  >
                    <Box>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 'medium',
                          color: 'light-gray-text.main',
                          backgroundColor: 'gray-background.main',
                          paddingTop: 1,
                          paddingBottom: 1,
                          paddingRight: 1,
                          paddingLeft: 1,
                        }}
                      >
                        Minimum fit
                      </Typography>
                    </Box>
                    <Box display="flex" flexDirection="row" marginBottom={0.5}>
                      <StarRateRounded color="yellow-01" fontSize="small" />
                      <StarRateRounded color="gray-line" fontSize="small" />
                      <StarRateRounded color="gray-line" fontSize="small" />
                      <StarRateRounded color="gray-line" fontSize="small" />
                      <StarRateRounded color="gray-line" fontSize="small" />
                    </Box>
                  </Box>
                </Typography>
              </Box>
              <Divider
                color="light-gray-text.main"
                sx={{ marginLeft: '40px', marginRight: '40px', opacity: 0.2, marginTop: 1.5 }}
              />
              {/* ----------------------------------------------------------------------- */}

              {/* ----------------------- Educational background ------------------------ */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '15px',
                  marginLeft: 6.5,
                  marginTop: 2.5,
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  Educational background
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '15px',
                  marginLeft: 6.5,
                  marginRight: 6.5,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ color: 'light-gray-text.main', fontWeight: 'regular' }}
                >
                  The educational background is not provided, making it difficult to assess its
                  relevance to the job requirements.
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '15px',
                  marginLeft: 6.5,
                  marginRight: 6.5,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ color: 'light-gray-text.main', fontWeight: 'regular', width: '100%' }}
                >
                  <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    justifyContent="space-between"
                    width="100%"
                  >
                    <Box>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 'medium',
                          color: 'light-gray-text.main',
                          backgroundColor: 'gray-background.main',
                          paddingTop: 1,
                          paddingBottom: 1,
                          paddingRight: 1,
                          paddingLeft: 1,
                        }}
                      >
                        Minimum fit
                      </Typography>
                    </Box>
                    <Box display="flex" flexDirection="row" marginBottom={0.5}>
                      <StarRateRounded color="yellow-01" fontSize="small" />
                      <StarRateRounded color="gray-line" fontSize="small" />
                      <StarRateRounded color="gray-line" fontSize="small" />
                      <StarRateRounded color="gray-line" fontSize="small" />
                      <StarRateRounded color="gray-line" fontSize="small" />
                    </Box>
                  </Box>
                </Typography>
              </Box>
              {/* --------------------------------------------------------------------- */}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}
export default JobFitEmptyCard
